"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PillSize = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var PillSize;
exports.PillSize = PillSize;

(function (PillSize) {
  PillSize["Primary"] = "primary";
  PillSize["secondary"] = "secondary";
})(PillSize || (exports.PillSize = PillSize = {}));

var Pill = function Pill(_ref) {
  var type = _ref.type,
      label = _ref.label,
      name = _ref.name,
      children = _ref.children,
      className = _ref.className,
      onRemove = _ref.onRemove,
      dataTestId = _ref.dataTestId;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].pillWrapper, className)
  }, _react["default"].createElement("div", {
    "data-test-id": dataTestId,
    className: (0, _classnames["default"])(_index["default"].pill, _index["default"][type], (0, _defineProperty2["default"])({}, _index["default"].removable, !!onRemove))
  }, label || children, onRemove && _react["default"].createElement("button", {
    className: _index["default"].removeIconWrapper,
    "aria-label": "remove ".concat(label || name),
    onClick: onRemove
  }, _react["default"].createElement(_icon["default"], {
    type: "cross",
    className: _index["default"].removeIcon,
    size: "small"
  }))));
};

Pill.defaultProps = {
  type: 'primary'
};
var _default = Pill;
exports["default"] = _default;